// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/Modal/modal.scss
// module id = 866
// module chunks = 0